import AccessibilityAnnouncer from 'components/AccessibilityAnnouncer';
import Layout from 'components/Layout';
import Loading from 'components/Loading/Loading';
import ProgressBar from 'components/ProgressBar';
import SkipIdentification from 'components/SkipIdentification/SkipIdentification';
import { IdentificationMethod } from 'redux/types';
import VideoIdentificationWindow from 'sections/VideoIdentificationWindow';
import useVideoIdent from 'utils/hooks/useVideoIdent';
import VideoIdentificationSuccesful from './VideoIdentificationSuccessful';

const VideoIdentification = () => {
  const {
    identificationIsSuccessful,
    identificationIsPending,
    identificationUrl,
    identificationId,
    identificationReference,
    isLoading,
    isMobile,
    identCancel,
    announceIFrame,
    setAnnounceIFrame,
  } = useVideoIdent();

  let content = null;

  if (isLoading) {
    content = <Loading type="initializing" />;
  }

  if (identificationIsPending) {
    content = (
      <VideoIdentificationWindow
        isMobile={isMobile}
        identificationReference={identificationReference}
        identificationId={identificationId}
        identificationUrl={identificationUrl}
        cancelAction={identCancel}
        setAnnounceIFrame={setAnnounceIFrame}
      />
    );
  }
  if (identificationIsSuccessful) {
    content = (
      <VideoIdentificationSuccesful padding-top="0" padding-bottom="0" />
    );
  }

  return (
    <Layout>
      <SkipIdentification />
      {!identificationIsSuccessful && (
        <ProgressBar step={0} type={IdentificationMethod.IDNOW} />
      )}
      {/* This announcer is only here to announce when the iframe is loaded since the live region does not announce this by itself */}
      <AccessibilityAnnouncer
        customAnnouncementIntlKey={
          announceIFrame ? 'message.iFrame.announcement.idnow' : undefined
        }
      />
      <div role="status" aria-live="polite" aria-atomic="false">
        {content}
      </div>
    </Layout>
  );
};

export default VideoIdentification;
